import { useEffect, useRef, useState } from 'react';

import { changeNextgenUiStatus } from '../../../nextgen/actions';
import { getDeviceViewPort } from '../../../utils/device';
import { getIsNextGenUI } from '../../../nextgen/selectors';
import { getStoreData } from '../../selectors';
import { isMobileOnly } from 'react-device-detect';
import { logoEditingStatusEnum } from '../../../utils/constants';
import styles from './UploadButton.scss';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import useUploadMultiple from '../../../nextgen/hook/useUploadMultiple';

export default function UploadButton(props) {
  const buttonRef = useRef(null);
  const dispatch = useDispatch();
  const { logoEditingStatus } = useSelector(getStoreData);
  const [fileSelector, setFileSelector] = useState(null);
  const upload = useUploadMultiple();
  const isNextgenUi = useSelector(getIsNextGenUI);

  useEffect(() => {
    const inputFileChanged = (event) => {
      if (event.target.files.length > 0) {
        if (isNextgenUi) {
          dispatch(
            changeNextgenUiStatus({
              uploadMultiple: { files: Array.from(event.target.files), props: { ...props, allowMultiple: true } },
            })
          );
        } else {
          upload.upload.call(this, event.target.files[0], props);
        }
      }
    };

    if (
      logoEditingStatus.currentStatus !== logoEditingStatusEnum.BackgroundRemoveWhite &&
      logoEditingStatus.currentStatus !== logoEditingStatusEnum.BackgroundRotate &&
      logoEditingStatus.currentStatus !== logoEditingStatusEnum.BackgroundCrop
    ) {
      const parentStyle = window.getComputedStyle(buttonRef.current.parentNode, false);
      buttonRef.current.style.width = parentStyle.width;
      buttonRef.current.style.height = parentStyle.height;
    }

    const buildFileSelector = () => {
      const fileSelect = document.createElement('input');
      fileSelect.setAttribute('type', 'file');
      if (props.allowMultiple) fileSelect.setAttribute('multiple', 'true');
      fileSelect.setAttribute('accept', '.jpg,.tif,.eps,.pdf,.ai,.psd,.gif,.bmp,.png');
      fileSelect.onchange = inputFileChanged;
      return fileSelect;
    };

    setFileSelector(buildFileSelector());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const uploadButtonClicked = (e, fileSelector) => {
    e.preventDefault();
    if (props.onClick) props.onClick(e);
    fileSelector.click();
  };

  return (
    <div
      ref={buttonRef}
      className={`${styles['userimage-uploadbutton']} ${props.className}`}
      style={isMobileOnly ? { width: (getDeviceViewPort().width - 30) / 2 } : {}}
      onClick={(e) => uploadButtonClicked(e, fileSelector)}></div>
  );
}
